import {
  PieChart as RechartsPieChart,
  Pie,
  Cell,
  Tooltip,
  ResponsiveContainer,
  Legend
} from "recharts";

interface PieChartProps {
  data: any[];
  options?: {
    title?: string;
    xAxisKey?: string;
    yAxisKey?: string;
    colors?: string[];
  };
}

const DEFAULT_COLORS = ["#2563eb", "#3b82f6", "#60a5fa", "#93c5fd", "#bfdbfe"];

export function PieChart({ data, options = {} }: PieChartProps) {
  const {
    title,
    xAxisKey = "name",
    yAxisKey = "value",
    colors = DEFAULT_COLORS
  } = options;

  return (
    <div className="w-full">
      {title && (
        <h3 className="text-lg font-semibold text-center mb-4">{title}</h3>
      )}
      <ResponsiveContainer width="100%" height={300}>
        <RechartsPieChart>
          <Pie
            data={data}
            dataKey={yAxisKey}
            nameKey={xAxisKey}
            cx="50%"
            cy="50%"
            outerRadius={100}
            label
          >
            {data.map((index) => (
              <Cell
                key={`cell-${index}`}
                fill={colors[index % colors.length]}
              />
            ))}
          </Pie>
          <Tooltip />
          <Legend />
        </RechartsPieChart>
      </ResponsiveContainer>
    </div>
  );
}
